module.exports = __webpack_public_path__ + "img/logo.bbcec6f0.svg";